import { ConfirmModal } from 'components/project/ClerkScreen';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

export const WatchModeOverlay = observer(() => {
  const {
    BidStore: {
      auction: { monitorChatOnly },
    },
    UIStore: { handleMonitorChatOnly },
  } = useStores();

  if (!monitorChatOnly) return null;

  return (
    <ConfirmModal
      // confirmText="DISABLE WATCH MODE"
      confirmText={null}
      message={
        'For safety reasons, we have locked all functions on this main clerk screen since you currently in watch mode. IF YOU MUST, you are able to disable watch mode by clicking the checkbox above the chat messages; otherwise, just click the "CANCEL" button to close this modal and remain in watch mode.'
      }
      onConfirm={() => handleMonitorChatOnly(false)}
      renderLink={(modal) => (
        <BlockerOverlay onClick={modal.open}>
          <div>Watch Mode</div>
          <div>(Locked)</div>
        </BlockerOverlay>
      )}
      title="IN WATCH MODE, MAIN CLERK FUNCTIONS DISABLED..."
    />
  );
});

export default WatchModeOverlay;

export const BlockerOverlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.2);
  position: absolute;
  height: 100vh;
  width: max(67%, 860px);
  top: 50px;
  left: 50px;
  font-size: 5rem;
  font-weight: bold;
  text-transform: uppercase;
  z-index: 10;
`;
